// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Sotre & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
import useMerchantUserStore from '@/app/store/modules/merchantUser';
import actionsMerchantUsers from '../../api/actionsMerchantUsers';
// Components
import DataTable from '@/common-utils/components/renders/dataTable/DataTable';
// Common
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import { columnsMerchantUsers, columnsMerchantUsersId } from './columnDef/columnsMerchantUsers';
import { useParams } from 'react-router-dom';

/**
 * @param root0
 * @param root0.pageActions
 * @param root0.filtersEventName
 * @returns {JSX} MerchantUsersTable
 */
function MerchantUsersTable({ pageActions = undefined, filtersEventName }) {

    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchMerchantUsers: refetchFromStore, storeRefetchMerchantUsers, query: queryStored, storeQuery } = useMerchantUserStore();

    // Constants
    const initialQuery = getInitialQuery();

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { contractAccessId: merchantAccountId } = useParams();
    const { data, isFetching, error, refetch } = actionsMerchantUsers.getMerchantUsers({ query, merchantAccountId }, false);

    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchMerchantUsers(false);
        }
    }, [query, launchRefetch, refetchFromStore]);

    const allColumns = columnsMerchantUsers({ query, setQuery, queryStored, storeQuery, setLaunchRefetch, filtersEventName });

    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            error={error}
            refetch={refetch}
            columnsId={columnsMerchantUsersId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQuery}
            setLaunchRefetch={setLaunchRefetch}

            pageActions={pageActions}
        />
    );
}

MerchantUsersTable.propTypes = {
    pageActions: PropTypes.node,
    filtersEventName: PropTypes.string
};

export default MerchantUsersTable;